import type { ShiritoriGameStore } from '@/game/core/game.store';
import { useEffect, useState } from 'react';
import { SpinLoader } from '../loader/spin-loader';
import type { ShiritoriWordDto } from '@/game/core/shiritori-word';
import type { TurnWordChoice } from '@/game/core/turn';
import MissingImgSrc from '../../assets/image/missing_image.webp';

interface GameImageProps {
    game: ShiritoriGameStore;
    match: ShiritoriWordDto | TurnWordChoice;
    className?: string;
}

export function GameImage({ game, match, className = 'p-2' }: GameImageProps) {
    const [imageSrc, setImageSrc] = useState('');

    useEffect(() => {
        game.getImageSrc(match.imageId)
            .then((imageSrc) => {
                const src = imageSrc || MissingImgSrc;
                setImageSrc(src);
            });
    }, [game, match.imageId]);

    return (
        <span className={`block w-full aspect-square overflow-hidden rounded-lg ${className}`}>
            {!imageSrc && (
                <span className="w-full h-full flex justify-center items-center">
                    <SpinLoader />
                </span>
            )}
            {imageSrc && <img src={imageSrc} className="w-full h-full object-contain" title={match.kana} alt={match.kana} />}
        </span>
    );
}
